import type {ReactElement} from 'react';
import React, {useState} from 'react';
import useDefaultPanelClose from '@Panels/hooks/useDefaultPanelClose';
import {Panel, PanelHeader} from '@Components/panel';
import {useUpdateEffect} from 'ahooks';
import {BorderEffectOptions} from '@Panels/poster-editor-item-effects-panel/components/border-effect-options';
import {BorderMobileColorPanel} from '@Panels/poster-editor-item-effects-panel/components/border-mobile-color-panel';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';

interface PosterEditorLayoutItemBorderPanelProps {
  panelId: string;
}

enum LayoutBorderPanels {
  DEFAULT = 'DEFAULT',
  COLOR_PICKER = 'COLOR_PICKER',
}

export default function PosterEditorLayoutItemBorderPanel({...props}: PosterEditorLayoutItemBorderPanelProps): ReactElement {
  const onClose = useDefaultPanelClose(props.panelId);
  const [currentlySelectedPanel, setCurrentlySelectedPanel] = useState(LayoutBorderPanels.DEFAULT);
  const activeItemId = useSingleActivePosterItemId();

  useUpdateEffect((): void => {
    onClose();
  }, [activeItemId]);

  const getHeader = (): ReactElement => {
    return <PanelHeader onClose={onClose} title={window.i18next.t('pmwjs_border')} />;
  };

  const getContent = (): ReactElement => {
    return (
      <BorderEffectOptions
        panelId={props.panelId}
        onClickColorFill={(): void => {
          setCurrentlySelectedPanel(LayoutBorderPanels.COLOR_PICKER);
        }}
      />
    );
  };

  const getPanels = (): ReactElement => {
    switch (currentlySelectedPanel) {
      case LayoutBorderPanels.COLOR_PICKER:
        return (
          <BorderMobileColorPanel
            onBack={(): void => {
              setCurrentlySelectedPanel(LayoutBorderPanels.DEFAULT);
            }}
            onClose={onClose}
            panelId={props.panelId}
          />
        );
      case LayoutBorderPanels.DEFAULT:
      default:
        return <Panel panelHeader={getHeader()} panelContent={getContent()} />;
    }
  };

  return getPanels();
}
